// extracted by css-extract-rspack-plugin
export default {"lite":"lite-JOi70k","content":"content-MFRzhD"};